import {Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {ObjectBaseComponent} from '../../../../../../core/shared/object/mvs-object-base/object-base.component';
import {NavigationItem} from '../../../../../../core/shared/dto/navigation/navigation-item';
import {MvsCoreService} from '../../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../../core/shared/service/message/mvs-message.service';
import {ConfirmationService} from 'primeng/api';
import {ObserverService} from '../../../../../../core/shared/object/service/observer.service';

@Component({
    selector: 'campaign-type-config-object-component',
    templateUrl: './campaign-type-config-object.component.html',
    styleUrls: ['./campaign-type-config-object.component.scss'],
    standalone: false
})
export class CampaignTypeConfigObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    @Output() onNavigationItems = new EventEmitter<NavigationItem[]>();

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        const title = `${this.dto.name} - Konfiguration`;
        this.setPageTitle(title);
    }

    ngOnChanges(changes: any): void {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    handleNavigationItems(navigationItems: NavigationItem[]): void {
        this.onNavigationItems.emit(navigationItems);
    }

    handleNavigationChange(navigationItem: NavigationItem): void {
        const menuItems: any[] = [];
        this.handleBreadcrumbItems(menuItems);
    }
}
